import { useState } from "react";
import { createContext } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import { getRenewalsUserService } from "./../../../services/userServices";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { deleteRenewalAdminService } from "../../../services/adminServices";

export const renewalUserContext = createContext({
  renewals: [],
  setRenewals: () => {},
  renewal: {},
  setRenewal: () => {},
  sort: "",
  setSort: () => {},
  invoiceStatus: "",
  setInvoiceStatus: () => {},
  start: "",
  setStart: () => {},
  end: "",
  setEnd: () => {},
  pageCount: null,
  setPageCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  itemsCount: null,
  setItemsCount: () => {},
  handleGetRenewals: () => {},
  handleDeleteRenewal: () => {},
});

const RenewalUserContext = ({ children }) => {
  const dispatch = useDispatch();

  const { user, order, invoice } = useParams();

  const [renewals, setRenewals] = useState([]);
  const [renewal, setRenewal] = useState({});
  const [sort, setSort] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsCount, setItemsCount] = useState(100);

  // Get Renewals
  const handleGetRenewals = async (event) => {
    event?.preventDefault();

    const objData = {
      ...(start && { start }),
      ...(end && { end }),
      ...(invoice && { invoice }),
      ...(order && { order }),
      ...(user && { user }),
      ...(invoiceStatus && { invoiceStatus }),
      pageNumber,
      sort,
      itemsCount,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getRenewalsUserService(objData);
      if (status === 200) {
        setRenewals(data.result?.renewals);
        setPageCount(data?.result?.allPagesCount);
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete Renewal
  const handleDeleteRenewal = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await deleteRenewalAdminService(id);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetRenewals();
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <renewalUserContext.Provider
      value={{
        renewals,
        setRenewals,
        renewal,
        setRenewal,
        sort,
        setSort,
        invoiceStatus,
        setInvoiceStatus,
        start,
        setStart,
        end,
        setEnd,
        pageCount,
        setPageCount,
        pageNumber,
        setPageNumber,
        itemsCount,
        setItemsCount,
        handleGetRenewals,
        handleDeleteRenewal,
      }}
    >
      {children}
    </renewalUserContext.Provider>
  );
};

export default RenewalUserContext;
